import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const Container = styled.section`
  @media screen and (min-width: 1024px) {
    .hero-body {
      padding: 3rem 5rem !important;
    }
  }
`;

const Home = styled.div`
  background-image: linear-gradient(
      rgb(255 255 255 / 60%),
      rgb(216 196 196 / 60%)
    ),
    url(${(props) => props.bgImage});

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 4px;
`;
const data = [
  {
    id: 1,
    title: 'Bestsellers of the month',
    subtitle: 'Up to 50% Off',
    link: '/shop',
    bgImage: '/images/offer.png',
  },
  {
    id: 2,
    title: 'Summer Sale',
    subtitle: 'Up to 50% Off',
    link: '/shop',
    bgImage: '/images/secondOffer.png',
  },
];

const OfferItem = () => {
  return (
    <Container className="section">
      <div className="container">
        <div className="columns is-vcentered is-multiline is-variable is-4">
          {data.map((item) => (
            <div className="column is-6">
              <Home className="hero" bgImage={item.bgImage}>
                <div className="hero-body">
                  <h1 className="title is-3 has-text-weight-medium">
                    {item.title}
                  </h1>
                  <h2 className="subtitle has-text-weight-medium">
                    {item.subtitle}
                  </h2>
                  <Link to={item.link}>
                    <button
                      className="button is-medium is-warning has-text-black is-size-6 has-text-weight-semibold"
                      type="button"
                    >
                      <span>Shop Now</span>
                      <span className="icon is-medium">
                        <i className="fas fa-arrow-right" />
                      </span>
                    </button>
                  </Link>
                </div>
              </Home>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default OfferItem;
